export default {
  namespaced: true,
  state: {
    errors: []
  },
  mutations: {
    ADD_ERROR(state, error) {
      if (Array.isArray(error)) {
        state.errors = [...state.errors, ...error]
      } else {
        state.errors = [...state.errors, error]
      }
    },
    CLEAR_ERRORS(state) {
      state.errors = []
    }
  }
}